import { getPrimaryColor } from '@orcar/common-d2c';
import styled from 'styled-components';
import { app } from '@/constants/common';

const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  display: flex;
  height: 60px;
  border-bottom: 1px solid ${({ theme }) => theme.COLOR.GREY_03};
`;

export const Tab = styled(FlexContainer)<{ isActive?: boolean }>`
  flex: 1;
  ${({ theme, isActive }) => (isActive ? theme.FONT.H4 : theme.FONT.B1)};
  font-size: 16px;
  color: ${({ theme, isActive }) =>
    isActive ? getPrimaryColor(app) : theme.COLOR.GREY_02};
  border-bottom: ${({ theme, isActive }) =>
    isActive && `4px solid ${getPrimaryColor(app)}`};
`;

export const SubTabWrapper = styled.div`
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  height: 60px;
  display: flex;
`;

export const SubTab = styled(FlexContainer)<{ isActive?: boolean }>`
  width: 50%;
  color: ${({ theme, isActive }) =>
    isActive ? getPrimaryColor(app) : theme.COLOR.GREY_02};
  border-bottom: 1px solid ${({ theme }) => theme.COLOR.GREY_03};
  font-weight: 600;
  font-size: 16px;
  line-height: 19.09px;
`;
